<template>
    <v-menu v-model="menuVisible" location="bottom" class="timetracking-menu" :close-on-content-click="false"
        transition="slide-y-transition" width="500" max-height="700">
        <template v-slot:activator="{ props }">
            <div class="k-card-border-hover assignee-container  cursor-pointer" v-bind="props">

                <TimeSpentToggle variant="chip" :meta="metaData"></TimeSpentToggle>

                <v-list-item class="px-1">
                    <template v-slot:prepend>
                        <div class="border-selected">
                            <v-avatar color="var(--neutral-100)" size="35" :class="['rounded-xl assignee-avatar']">
                                <v-icon size="18" color="#bbbbbb">fal fa-stopwatch</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <v-list-item-title>{{ formattedTotalTime }}</v-list-item-title>
                </v-list-item>
            </div>
        </template>

        <v-card class="card card-sm k-card-border z-index-1">
            <v-row class="pb-3">
                <v-col cols="6">
                    <h6>Time tracking</h6>
                </v-col>
                <v-col cols="6" class="text-right">
                    <p>{{ formattedTotalTime }}</p>
                </v-col>
            </v-row>

            <!-- <TimeTrackingForm :timeSpent="timeSpent" :users="users" :current_user_id="current_user_id"
                @add-time="addTime" :fielddata="timeSpent" /> -->

            <v-form @submit.prevent="addTime" class="pa-0 k-card-border z-index-1">
                <div class="pa-1 rounded-lt-lg">
                    <userstagmenu class="my-auto" type="chip" size="small" :users="users" :selected="selectedUser"
                        @update:value="updateAssignee" show_names />
                </div>
                <div class="pa-3">
                    <v-row class="">
                        <v-col cols="6">
                            <v-text-field v-model="newTime.hours" type="text" @input="validateHours" inputmode="numeric"
                                min="0" suffix="Uren" density="compact" variant="solo" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="6" class="text-right">
                            <v-text-field v-model="newTime.minutes" type="text" @input="validateMinutes"
                                inputmode="numeric" min="0" max="59" suffix="Minuten" density="compact" variant="solo"
                                hide-details> </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <VueDatePicker v-model="dateTimeRange" :format="'dd-MM-yyyy HH:mm'"
                                @update:modelValue="updateTicket" :clearable="true" :locale="'nl'" range multi-calendars
                                :show-time="true" placeholder="Datum en tijd" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field prepend-inner-icon="fal fa-text" v-model="newTime.description"
                                placeholder="Notitie" variant="solo" density="compact" hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <div class="pa-3 py-2 d-flex my-auto">
                    <div>
                        <v-switch inset v-model="newTime.billable" color="primary" classs="billable-switch"
                            label="Billable" density="compact" hide-details></v-switch>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                        <v-btn class="btn btn-sm" color="primary" type="submit" block>Opslaan</v-btn>
                    </div>
                </div>
            </v-form>

            <v-divider class="my-3"></v-divider>

            <timetrackinglist :timeSpent="timeSpent || []" :users="users" :current_user_id="current_user_id"
                @edit-time="editTime" @update:remove-timespend="removeTime" />
        </v-card>

    </v-menu>
</template>

<script>
import timetrackinglist from "@/components/dashboards/datafields/timetrackinglist.vue";
// import TimeTrackingForm from "@/components/dashboards/datafields/timetrackingform.vue";
import TimeSpentToggle from "@/components/timespents/TimeSpentToggle.vue";
export default {
    name: "TimeTrackingMenu",
    props: {
        timeSpent: { type: Array, required: true },
        taskId: { type: Number, default: null },
        ticketId: { type: Number, default: null },
        users: { type: Array, required: true },
        current_user_id: { type: Number, required: true }
    },
    components: {
        timetrackinglist,
        // TimeTrackingForm
        TimeSpentToggle
    },
    data() {
        return {
            menuVisible: false,
            newTime: {
                time: '',
                start_time: '',
                end_time: '',
                description: '',
                user_id: '',
                billable: false
            },
            dateTimeRange: [null, null],
            editDialog: false,
            editedTime: '',
            currentEdit: null
        };
    },
    computed: {
        totalTimeInMinutes() {
            return (parseInt(this.newTime.hours) || 0) * 60 + (parseInt(this.newTime.minutes) || 0);
        },
        formattedTotalTime() {
            if (!Array.isArray(this.timeSpent)) {
                console.error("timeSpent is not an array", this.timeSpent);
                return "0u 0m";
            }
            const totalMinutes = this.timeSpent.reduce((sum, entry) => sum + (entry.time || 0), 0);
            return this.formatTime(totalMinutes);
        },
        groupedTime() {
            return this.timeSpent.reduce((acc, entry) => {
                const userId = entry.user_id;
                if (!acc[userId]) {
                    acc[userId] = {
                        user: this.users.find(user => user.id === userId),
                        totalTime: 0
                    };
                }
                acc[userId].totalTime += entry.time;
                return acc;
            }, {});
        },
        selectedUser() {
            if (!this.newTime.user_id) {
                this.newTime.user_id = this.current_user_id;
                return this.current_user_id;
            } else {
                return this.newTime.user_id;
            }
        },
        formattedDate() {
            if (this.newTime.start_time && this.newTime.end_time) {
                return `${this.formatDate(this.newTime.start_time)} - ${this.formatDate(this.newTime.end_time)}`;
            } else {
                return 'Selecteer een datumbereik';
            }
        }
    },
    created() {
        this.setDefaultDateTime();
    },
    watch: {
        "newTime.hours": "updateTotalTime",
        "newTime.minutes": "updateTotalTime",
        "newTime.time": "updateTotalTime",
        "newTime.user_id": "updateAssignee",

        dateTimeRange(newRange) {
            this.updateTimeRange(newRange);
        },
        timeSpent(newVal) {
    if (!Array.isArray(newVal)) {
      console.error("Invalid timeSpent:", newVal);
    }
  }

    },
    methods: {
        metaData() {
            return {
                ticket_id: this.ticketId,
                task_id: this.taskId
            };
        },
        setDefaultDateTime() {
            const now = new Date();
            const startOfDay = new Date(now.setHours(0, 0, 0, 0));
            const endOfDay = new Date(startOfDay.getTime() + (60 * 60 * 1000));

            if (!this.dateTimeRange[0] && !this.dateTimeRange[1]) {
                this.dateTimeRange = [startOfDay, endOfDay];
            }

            this.newTime.start_time = this.dateTimeRange[0].getTime() / 1000;
            this.newTime.end_time = this.dateTimeRange[1].getTime() / 1000;
        },
        updateTimeRange(dateRange) {
            if (dateRange && dateRange[0] && dateRange[1]) {
                this.newTime.start_time = new Date(dateRange[0]).getTime() / 1000;
                this.newTime.end_time = new Date(dateRange[1]).getTime() / 1000;
                this.calculateTimeDifference();
            }
        },
        calculateTimeDifference() {
            if (this.newTime.start_time && this.newTime.end_time) {
                const startDate = new Date(this.newTime.start_time * 1000);
                const endDate = new Date(this.newTime.end_time * 1000);

                const diffInMilliseconds = endDate - startDate;
                const diffInMinutes = Math.floor(diffInMilliseconds / 60000); // Minuten
                const hours = Math.floor(diffInMinutes / 60); // Uren
                const minutes = diffInMinutes % 60; // Rest van de minuten

                this.newTime.hours = hours;
                this.newTime.minutes = minutes;
            }
        },
        validateHours() {
            this.newTime.hours = this.newTime.hours.replace(/\D/g, '');
        },
        validateMinutes() {
            this.newTime.minutes = this.newTime.minutes.replace(/\D/g, '');
            if (parseInt(this.newTime.minutes) > 59) {
                this.newTime.minutes = 59;
            }
        },
        updateTotalTime() {
            this.newTime.time = (parseInt(this.newTime.hours) || 0) * 60 + (parseInt(this.newTime.minutes) || 0);
        },
        updateAssignee(usersId) {
            console.log('user', usersId);
            this.newTime.user_id = usersId;
        },
        formatTime(minutes) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours}u ${remainingMinutes}m`;
        },
        addTime() {
            const payload = {
                task_id: this.taskId,
                ticket_id: this.ticketId,
                user_id: this.newTime.user_id = parseInt(this.newTime.user_id, 10),
                time: parseInt(this.newTime.time),
                start: this.newTime.start_time,
                end: this.newTime.end_time,
                source: "manual",
                billable: this.newTime.billable,
                description: this.newTime.description,
            };

            this.$emit("add-time", payload);
            this.resetForm();
        },

        removeTime(entry) {
            this.$emit("delete-time", entry);
        },
        resetForm() {
            this.newTime = {
                time: '',
                start_time: '',
                end_time: '',
                description: '',
                user_id: '',
                billable: false
            };
        },
        updateTicket(dateRange) {
            // Update this with the values of the new range
            if (dateRange && dateRange[0] && dateRange[1]) {
                this.newTime.start_time = new Date(dateRange[0]).getTime() / 1000;
                this.newTime.end_time = new Date(dateRange[1]).getTime() / 1000;
                this.calculateTimeDifference();
            }
        }
    }
};
</script>


<style>
.z-index-1 {
    z-index: 1;
    overflow: visible !important;
}


:root {
    /*General*/
    --dp-font-family: 'Gilroy';
    --dp-border-radius: 8px;
    /*Configurable border-radius*/
    --dp-cell-border-radius: 6px;
    /*Specific border radius for the calendar cell*/
    --dp-common-transition: all 0.1s ease-in;
    /*Generic transition applied on buttons and calendar cells*/

    /*Sizing*/
    --dp-button-height: 35px;
    /*Size for buttons in overlays*/
    --dp-month-year-row-height: 35px;
    /*Height of the month-year select row*/
    --dp-month-year-row-button-size: 35px;
    /*Specific height for the next/previous buttons*/
    --dp-button-icon-height: 20px;
    /*Icon sizing in buttons*/
    --dp-cell-size: 35px;
    /*Width and height of calendar cell*/
    --dp-cell-padding: 5px;
    /*Padding in the cell*/
    --dp-common-padding: 10px;
    /*Common padding used*/
    --dp-input-icon-padding: 35px;
    /*Padding on the left side of the input if icon is present*/
    --dp-input-padding: 6px 30px 6px 12px;
    /*Padding in the input*/
    --dp-menu-min-width: 260px;
    /*Adjust the min width of the menu*/
    --dp-action-buttons-padding: 2px 5px;
    /*Adjust padding for the action buttons in action row*/
    --dp-row-margin: 5px 0;
    /*Adjust the spacing between rows in the calendar*/
    --dp-calendar-header-cell-padding: 0.5rem;
    /*Adjust padding in calendar header cells*/
    --dp-two-calendars-spacing: 10px;
    /*Space between multiple calendars*/
    --dp-overlay-col-padding: 3px;
    /*Padding in the overlay column*/
    --dp-time-inc-dec-button-size: 32px;
    /*Sizing for arrow buttons in the time picker*/
    --dp-menu-padding: 6px 8px;
    /*Menu padding*/

    /*Font sizes*/
    --dp-font-size: 16px;
    /*Default font-size*/
    --dp-preview-font-size: 14px;
    /*Font size of the date preview in the action row*/
    --dp-time-font-size: 14px;
    /*Font size in the time picker*/

    /*Transitions*/
    --dp-animation-duration: 0.1s;
    /*Transition duration*/
    --dp-menu-appear-transition-timing: cubic-bezier(.4, 0, 1, 1);
    /*Timing on menu appear animation*/
    --dp-transition-timing: ease-out;
    /*Timing on slide animations*/
}

.dp__theme_light {
    --dp-background-color: #fff;
    --dp-text-color: #212121;
    --dp-hover-color: #f3f3f3;
    --dp-hover-text-color: #212121;
    --dp-hover-icon-color: #959595;
    --dp-primary-color: #24a1c7;
    --dp-primary-disabled-color: #24a1c750;
    --dp-primary-text-color: #f8f5f5;
    --dp-secondary-color: #c0c4cc;
    --dp-border-color: #ddd;
    --dp-menu-border-color: #ddd;
    --dp-border-color-hover: #aaaeb7;
    --dp-border-color-focus: #aaaeb7;
    --dp-disabled-color: #f6f6f6;
    --dp-scroll-bar-background: #f3f3f3;
    --dp-scroll-bar-color: #959595;
    --dp-success-color: #76d275;
    --dp-success-color-disabled: #a3d9b1;
    --dp-icon-color: #959595;
    --dp-danger-color: #ff6f60;
    --dp-marker-color: #ff6f60;
    --dp-tooltip-color: #fafafa;
    --dp-disabled-color-text: #8e8e8e;
    --dp-highlight-color: rgb(25 118 210 / 10%);
    --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
    --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
    --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
}
</style>